/**
 * Gives the centered and cropped logo name depending on the given provider name
 * @param providerName
 */
export function logoNameMapper(providerName) {
  if (providerName.includes('1822')) {
    return {
      centered: 'spk1822direkt',
      cropped: 'spk1822direkt_cropped'
    };
  }
  if (providerName.includes('Allianz')) {
    return {
      centered: 'allianz',
      cropped: 'allianz_cropped'
    };
  }
  if (providerName.includes('ALTE LEIPZIGER')) {
    return {
      centered: 'alteLeipziger',
      cropped: 'alteLeipziger_cropped'
    };
  }
  if (providerName.includes('Augsburger Aktienbank')) {
    return {
      centered: 'aab',
      cropped: 'aab_cropped'
    };
  }
  if (providerName.includes('AXA')) {
    return {
      centered: 'axa',
      cropped: 'axa_cropped'
    };
  }
  if (providerName.includes('Baden-Württembergische Bank')) {
    return {
      centered: 'bwBank',
      cropped: 'bwBank_cropped'
    };
  }
  if (providerName.includes('Barmenia')) {
    return {
      centered: 'barmenia',
      cropped: 'barmenia_cropped'
    };
  }
  if (providerName.includes('Bausparkasse Mainz') || providerName.includes('BK Mainz') || providerName.includes('BKM')) {
    return {
      centered: 'bausparkasseMainz',
      cropped: 'bausparkasseMainz_cropped'
    };
  }
  if (providerName.includes('BBBank')) {
    return {
      centered: 'bbBank',
      cropped: 'bbBank_cropped'
    };
  }
  if (providerName.includes('BHW Bausparkasse AG') || providerName.includes('BHW Bausparkassen AG')) {
    return {
      centered: 'bhw',
      cropped: 'bhw_cropped'
    };
  }
  if (providerName.includes('Braunschweigische Landessparkasse')) {
    return {
      centered: 'blskSpk',
      cropped: 'blskSpk_cropped'
    };
  }
  if (providerName.includes('Commerzbank')) {
    return {
      centered: 'commerzbank',
      cropped: 'commerzbank_cropped'
    };
  }
  if (providerName.includes('Continentale')) {
    return {
      centered: 'continentale',
      cropped: 'continentale_cropped'
    };
  }
  if (providerName.includes('Deutsche Bank') || providerName.includes('DB')) {
    return {
      centered: 'deutscheBank',
      cropped: 'deutscheBank_cropped'
    };
  }
  if (providerName.includes('Deutsche Apotheker- und Ärztebank eG')) {
    return {
      centered: 'apoBank',
      cropped: 'apoBank_cropped'
    };
  }
  if (providerName.includes('ING')) {
    return {
      centered: 'ing',
      cropped: 'ing_cropped'
    };
  }
  if (providerName.includes('Degussa')) {
    return {
      centered: 'degussa',
      cropped: 'degussa_cropped'
    };
  }
  if (providerName.includes('Deutsche Kreditbank') || providerName.includes('DKB')) {
    return {
      centered: 'dkb',
      cropped: 'dkb_cropped'
    };
  }
  if (providerName.includes('DSL Bank') || providerName.includes('DSL Privatdarlehen')) {
    return {
      centered: 'dsl',
      cropped: 'dsl_cropped'
    };
  }
  if (providerName.includes('DZ HYP')) {
    return {
      centered: 'dzhyp',
      cropped: 'dzhyp'
    };
  }
  if (providerName.includes('ERGO')) {
    return {
      centered: 'ergo',
      cropped: 'ergo_cropped'
    };
  }
  if (providerName.includes('Evangelische Bank')) {
    return {
      centered: 'evangelischeBank',
      cropped: 'evangelischeBank_cropped'
    };
  }
  if (providerName.includes('Generali')) {
    return {
      centered: 'generali',
      cropped: 'generali_cropped'
    };
  }
  if (providerName.includes('Gladbacher')) {
    return {
      centered: 'gladbacherBank',
      cropped: 'gladbacherBank_cropped'
    };
  }
  if (providerName.includes('Hannoversche Lebensversicherung') || providerName.includes('Hannoversche Spezialprodukt') || providerName.includes('Hannoversche LV')) {
    return {
      centered: 'hannoversche',
      cropped: 'hannoversche_cropped'
    };
  }
  if (providerName.includes('Hanseatic')) {
    return {
      centered: 'hanseatic',
      cropped: 'hanseatic_cropped'
    };
  }
  if (providerName.includes('Hausbank München')) {
    return {
      centered: 'hausbankMuenchen',
      cropped: 'hausbankMuenchen_cropped'
    };
  }
  if (providerName.includes('Höchster Pensionskasse')) {
    return {
      centered: 'penka',
      cropped: 'penka_cropped'
    };
  }
  if (providerName.includes('Huk-Coburg') || providerName.includes('HUK-COBURG')) {
    return {
      centered: 'huk',
      cropped: 'huk_cropped'
    };
  }
  if (providerName.includes('HypoVereinsbank')) {
    return {
      centered: 'hypo',
      cropped: 'hypo_cropped'
    };
  }
  if (providerName.includes('KfW')) {
    return {
      centered: 'kfw',
      cropped: 'kfw_cropped'
    };
  }
  if (providerName.includes('Landessparkasse zu Oldenburg')) {
    return {
      centered: 'lzoSpk',
      cropped: 'lzoSpk_cropped'
    };
  }
  if (providerName.includes('LBS') || providerName.includes('Landesbausparkasse')) {
    return {
      centered: 'lbs',
      cropped: 'lbs_cropped'
    };
  }
  if (providerName.includes('Lloyds Bank')) {
    return {
      centered: 'lloydsbank',
      cropped: 'lloydsbank_cropped'
    };
  }
  if (providerName.includes('Münchener Hypothekenbank') || providerName.includes('MHyp') || providerName.includes('MHB')) {
    return {
      centered: 'mhyp',
      cropped: 'mhyp_cropped'
    };
  }
  if (providerName.includes('MLP')) {
    return {
      centered: 'mlp',
      cropped: 'mlp_cropped'
    };
  }
  if (providerName.includes('NORD/LB')) {
    return {
      centered: 'nordLb',
      cropped: 'nordLb_cropped'
    };
  }
  if (providerName.includes('PSD')) {
    return {
      centered: 'psd',
      cropped: 'psd_cropped'
    };
  }
  if (providerName.includes('Signal')) {
    return {
      centered: 'signalIduna',
      cropped: 'signalIduna_cropped'
    };
  }
  if (providerName.includes('Sparda')) {
    return {
      centered: 'sparda',
      cropped: 'sparda_cropped'
    };
  }
  if (providerName.includes('Stadtsparkasse München')) {
    return {
      centered: 'sparkasseMuenchen',
      cropped: 'sparkasseMuenchen_cropped'
    };
  }
  if (providerName.includes('Sparkasse zu Lübeck')) {
    return {
      centered: 'sparkasseLuebeck',
      cropped: 'sparkasseLuebeck_cropped'
    };
  }
  if (providerName.includes('Sparkasse Vorpommern')) {
    return {
      centered: 'sparkasseVorpommern',
      cropped: 'sparkasseVorpommern_cropped'
    };
  }
  if (providerName.includes('Oldenburgische Landesbank')) {
    return {
      centered: 'oldenburgLandesbank',
      cropped: 'oldenburgLandesbank_cropped'
    };
  }
  if (providerName.includes('SSK') || providerName.includes('SPK') || providerName.includes('Sparkasse') || providerName.includes('Kreissparkasse') || providerName.includes('Stadtsparkasse')) {
    return {
      centered: 'sparkasse',
      cropped: 'sparkasse_cropped'
    };
  }
  if (providerName.includes('Universa') || providerName.includes('uniVersa')) {
    return {
      centered: 'universa',
      cropped: 'universa_cropped'
    };
  }
  if (providerName.includes('VR-Bank Niederbayern-Oberpfalz')) {
    return {
      centered: 'vrBankNiederbayern',
      cropped: 'vrBankNiederbayern_cropped'
    };
  }
  if (providerName.includes('Volksbank') || providerName.includes('VR Bank') || providerName.includes('VR-Bank') || providerName.includes('VoBa') || providerName.includes('Voba') || providerName.includes('VR Rosenheim-Chiemsee') || providerName.includes('Raiffeisenbank') || providerName.includes('Raiba')) {
    return {
      centered: 'volksbank',
      cropped: 'volksbank_cropped'
    };
  }
  if (providerName.includes('Volkswohl Bund')) {
    return {
      centered: 'volkswohlBund',
      cropped: 'volkswohlBund_cropped'
    };
  }
  if (providerName.includes('Wüstenrot')) {
    return {
      centered: 'wuestenrot',
      cropped: 'wuestenrot_cropped'
    };
  }
  if (providerName.includes('Hamburger Sparkasse AG')) {
    return {
      centered: 'haspa',
      cropped: 'haspa_cropped'
    };
  }
  if (providerName.includes('Investitionsbank Berlin')) {
    return {
      centered: 'investitionsbankBerlin',
      cropped: 'investitionsbankBerlin_cropped'
    };
  }
  if (providerName.includes('Investitionsbank Schleswig-Holstein')) {
    return {
      centered: 'investitionsbankSh',
      cropped: 'investitionsbankSh_cropped'
    };
  }
  if (providerName.includes('LIGA Bank')) {
    return {
      centered: 'liga',
      cropped: 'liga_cropped'
    };
  }
  if (providerName.includes('LVM Versicherung')) {
    return {
      centered: 'lvm',
      cropped: 'lvm_cropped'
    };
  }
  if (providerName.includes('Provinzial Rheinland')) {
    return {
      centered: 'provinzial',
      cropped: 'provinzial_cropped'
    };
  }
  if (providerName.includes('Santander')) {
    return {
      centered: 'santander',
      cropped: 'santander_cropped'
    };
  }
  if (providerName.includes('Südwestbank')) {
    return {
      centered: 'suedwestbank',
      cropped: 'suedwestbank_cropped'
    };
  }
  if (providerName.includes('SV SparkassenVersicherung')) {
    return {
      centered: 'sv',
      cropped: 'sv_cropped'
    };
  }
  if (providerName.includes('Versicherungskammer Bayern')) {
    return {
      centered: 'vkb',
      cropped: 'vkb_cropped'
    };
  }
  if (providerName.includes('Versorgungswerk der Zahnärztekammer Nordrhein') || providerName.includes('VZN')) {
    return {
      centered: 'vzn',
      cropped: 'vzn_cropped'
    };
  }
  if (providerName.includes('start:bausparkasse AG')) {
    return {
      centered: 'startbausparkasse',
      cropped: 'startbausparkasse_cropped'
    };
  }
  return {
    centered: 'noLogo',
    cropped: 'noLogo_cropped'
  };
}